import React, { useEffect } from "react";
import Head from "next/head";
import { MoveBrasilPage } from "@/app/components/MoveBrasil/MoveBrasilPage";
import { dismissCookieConsentUi } from "@/app/utils/cookieConsent";

const MoveBrasilJeep: React.FC = () => {
	useEffect(() => {
		dismissCookieConsentUi();

		const prevHtmlOverflow = document.documentElement.style.overflowX;
		const prevBodyOverflow = document.body.style.overflowX;
		document.documentElement.style.overflowX = "hidden";
		document.body.style.overflowX = "hidden";

		const observer = new MutationObserver(() => dismissCookieConsentUi());
		observer.observe(document.body, { childList: true, subtree: true });

		return () => {
			observer.disconnect();
			document.documentElement.style.overflowX = prevHtmlOverflow;
			document.body.style.overflowX = prevBodyOverflow;
		};
	}, []);

	return (
		<>
			<Head>
				<title>Move Brasil — Jeep Renegade | Vitória Motors Jeep</title>
				<meta
					name="description"
					content="Motoristas de aplicativo e taxistas: troque seu carro por um Jeep Renegade zero quilômetro com o programa Move Brasil."
				/>
				<meta charSet="utf-8" />
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1.0"
				/>
			</Head>
			<MoveBrasilPage />
		</>
	);
};

export default React.memo(MoveBrasilJeep);
